import { isProd, isCdt } from "@/config/constants";

const ACCOUNT_BASE_URL = isProd
    ? "https://api.maersk.com/bowlerchart-registration-api/api/"
        : isCdt
            ? "https://api-cdt.maersk.com/bowlerchart-registration/api/"
            : "https://api-cdt.maersk.com/bowlerchart-registration/api/";

console.log("process.env.VUE_APP_ENV API endpoint =", process.env.VUE_APP_ENV);
console.log("ACCOUNT_BASE_URL API endpoint =", ACCOUNT_BASE_URL);

//Generic Bowler Chart
export const registerBowlerChartProduct = `${ACCOUNT_BASE_URL}registerBowlerChartProduct`;
export const extractProductSchemaInfo = `${ACCOUNT_BASE_URL}extractProductSchemaInfo`;
export const getBowlerChartProductDetails = `${ACCOUNT_BASE_URL}getBowlerChartProductDetails`;
export const deleteBowlerChartProduct = `${ACCOUNT_BASE_URL}deleteBowlerChartProduct`;
export const updateBowlerChartProduct = `${ACCOUNT_BASE_URL}updateBowlerChartProduct`;
export const updateProductMetadata = `${ACCOUNT_BASE_URL}updateProductMetadata`;
export const createMount = `${ACCOUNT_BASE_URL}createMount`;
export const fetchSavyintReadOnlyGroups = `${ACCOUNT_BASE_URL}fetchSavyintReadOnlyGroups`;
export const createSavyintAddRequest = `${ACCOUNT_BASE_URL}createSavyintAddRequest`;





